const Footer = () => {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-5 sm:px-8 pt-4 pb-8 bg-white">
      <img src="/images/logo-pink.svg" className="w-[85px] sm:w-[72px]" />

      <div className="caption-text flex flex-col sm:flex-row items-center sm:gap-2.5 text-primary-gray-400">
        Copyright ClassX 2025
        <img src="/images/icons/point.svg" className="hidden sm:block" />
        <div className="flex items-center gap-2.5 text-button font-button-medium sm:text-caption-text sm:font-caption-text">
          <a
            href="https://community.classx.tech/about/"
            target="_blank"
            className="underline"
          >
            About
          </a>
          <a
            href="https://blog.classx.tech/"
            target="_blank"
            className="underline"
          >
            Blog
          </a>
          <a
            href="https://www.linkedin.com/company/classx-tech"
            target="_blank"
            className="underline"
          >
            Careers
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
